import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@/auth/Auth'
import Empresas from '@/views/Empresas'
import Usuarios from '@/views/Usuarios'
import Paineis from '@/views/Paineis'
import Acessos from '@/views/Acessos'
import Site from '@/views/Site'
import Terminais from '@/views/Terminais'
import Grupos from '@/views/Grupos'
import Pessoas from '@/views/Pessoas'

import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
  { name: 'site', path: '/', component: Site, meta: { requiresAdmin: false } },
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'home', path: '/home', redirect: '/pessoas', meta: { requiresAdmin: true } },
  { name: 'empresas', path: '/empresas', component: Empresas, meta: { requiresAdmin: true } },
  { name: 'usuarios', path: '/usuarios', component: Usuarios, meta: { requiresAdmin: true } },
  { name: 'paineis', path: '/paineis', component: Paineis, meta: { requiresAdmin: true } },
  { name: 'acessos', path: '/acessos', component: Acessos, meta: { requiresAdmin: true } },
  { name: 'terminais', path: '/terminais', component: Terminais, meta: { requiresAdmin: true } },
  { name: 'grupos', path: '/grupos', component: Grupos, meta: { requiresAdmin: true } },
  { name: 'pessoas', path: '/pessoas', component: Pessoas, meta: { requiresAdmin: true } },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN")
      next()
    else
      next({ path: '/' })
  } else {
    next()
  }
})

export default router
